import React from "react"
import { ProductVariant } from "../../../../types/product"
import { isColorVariant, isQuantityVariant } from "../../../../utils/products"
import ProductColorDropdown from "../ProductColorDropdown"
import ProductQuantityDropdown from "../ProductQuantityDropdown"

interface Props {
  variants: ProductVariant[]
  selectedVariant: ProductVariant
  onVariantSelect: (variant: ProductVariant) => void
  fullWidth?: boolean
}

export const ProductVariantDropdown = ({
  variants,
  selectedVariant,
  onVariantSelect,
  fullWidth,
}: Props) => {
  return (
    <>
      {isColorVariant(selectedVariant) && (
        <ProductColorDropdown
          onVariantSelect={onVariantSelect}
          selectedVariant={selectedVariant}
          variants={variants}
          fullWidth={fullWidth}
        />
      )}
      {isQuantityVariant(selectedVariant) && (
        <ProductQuantityDropdown
          onVariantSelect={onVariantSelect}
          selectedVariant={selectedVariant}
          variants={variants}
          fullWidth={fullWidth}
        />
      )}
    </>
  )
}
